import {
  unavailableSessionAudioRecorder,
  type SessionAudioRecorder,
} from './recorder-port'
import {
  unavailableSessionRecordingUploader,
  type SessionRecordingUploader,
} from './uploader-port'

let recorder: SessionAudioRecorder | null = null
let uploader: SessionRecordingUploader | null = null
const listeners = new Set<() => void>()

/** The registered device recorder, or the unavailable fallback (web / not registered). */
export function getSessionAudioRecorder(): SessionAudioRecorder {
  return recorder ?? unavailableSessionAudioRecorder
}

export function getSessionRecordingUploader(): SessionRecordingUploader {
  return uploader ?? unavailableSessionRecordingUploader
}

/** Called once at app start by the native adapter module. */
export function registerSessionRecordingAdapters(next: {
  recorder?: SessionAudioRecorder
  uploader?: SessionRecordingUploader
}): void {
  if (next.recorder) recorder = next.recorder
  if (next.uploader) uploader = next.uploader
  listeners.forEach((listener) => listener())
}

/** For `useSyncExternalStore`: re-render when adapters are registered. */
export function subscribeSessionRecordingAdapters(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

/** Test helper. */
export function resetSessionRecordingAdaptersForTests(): void {
  recorder = null
  uploader = null
}
